<ion-app class="app">
  <div class="main" [ngClass]="getMainClasses()">
    <app-navbar></app-navbar>
    <div class="main-container">
      <app-left-side-bar></app-left-side-bar>
      <div class="content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>

  <div class="appLoader" [ngClass]="getAppLoaderClasses()">
    <ng-container *ngIf="!hasApiFailed; else errorTemplate">
      <ion-spinner name="circular" color="#fff"></ion-spinner>
      <p>Please Wait, Loading Next Best SKU Application...</p>
    </ng-container>

    <ng-template #errorTemplate>
      <ion-icon name="alert-circle-outline" size="large"></ion-icon>
      <p>Oops! Error with one of the API calls.</p>
      <ion-button class="error-button" fill="clear" (click)="retryApiCalls()">Retry</ion-button>
    </ng-template>
  </div>
</ion-app>
